import { jsx as _jsx } from "react/jsx-runtime";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";
import { NoResultsEmptyStateBase } from "@faire/retailer/components/NoResults/NoResultsEmptyStateBase";
var NoResultsContainerBase = function(param) {
    var onClearFilters = param.onClearFilters, className = param.className, hasFiltersApplied = param.hasFiltersApplied, showProductFirstResults = param.showProductFirstResults, divRef = param.divRef;
    var title = noResultsTitle;
    var subtitle = showBrandFirstSubtitle;
    if (hasFiltersApplied) {
        title = noFilteredResultsTitle;
        subtitle = hasFiltersAppliedSubtitle(onClearFilters);
    } else if (showProductFirstResults) {
        subtitle = showProductFirstSubtitle;
    }
    return /*#__PURE__*/ _jsx(NoResultsEmptyStateBase, {
        className: className,
        title: title,
        subtitle: subtitle,
        divRef: divRef
    });
};
export var NoResultsContainer = observer(NoResultsContainerBase);
var noResultsTitle = /*#__PURE__*/ _jsx(StrictLocalMsg, {
    id: "GfZOq+",
    defaultMessage: [
        {
            type: 0,
            value: "No results available"
        }
    ]
});
export var noFilteredResultsTitle = /*#__PURE__*/ _jsx(StrictLocalMsg, {
    id: "JmpNaC",
    defaultMessage: [
        {
            type: 0,
            value: "No results match these filters"
        }
    ]
});
export var hasFiltersAppliedSubtitle = function() {
    var onClearFilters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "1snLu3",
        defaultMessage: [
            {
                type: 0,
                value: "Adjust or clear your filters to see more results. "
            },
            {
                type: 8,
                value: "ButtonFormatting",
                children: [
                    {
                        type: 0,
                        value: "Clear Filters"
                    }
                ]
            }
        ],
        values: {
            ButtonFormatting: function(chunks) {
                return /*#__PURE__*/ _jsx(EmbeddedLink, {
                    onClick: onClearFilters,
                    children: chunks
                });
            }
        }
    });
};
var showProductFirstSubtitle = /*#__PURE__*/ _jsx(StrictLocalMsg, {
    id: "mcDOwO",
    defaultMessage: [
        {
            type: 0,
            value: "Try visiting other categories to discover more products"
        }
    ]
});
var showBrandFirstSubtitle = /*#__PURE__*/ _jsx(StrictLocalMsg, {
    id: "jniKs/",
    defaultMessage: [
        {
            type: 0,
            value: "Try visiting other categories to discover more brands"
        }
    ]
});
